import { useEffect, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function PaymentReturn() {
    const [params] = useSearchParams();
    const { refresh } = useAuth();
    const nav = useNavigate();
    const status = params.get("status") || "unknown";
    const plan = params.get("plan");

    const ok = status === "success";

    useEffect(() => {
        if (ok) refresh?.();
    }, [ok, refresh]);

    const Icon = ok ? CheckCircle2 : (status === "unknown" ? Loader2 : XCircle);
    const title = ok ? "You're all set 🎉" : (status === "unknown" ? "Confirming…" : "Payment didn't go through");
    const msg = ok
        ? `Your ${plan === "yearly" ? "Pro Yearly (Unlimited)" : "Pro Monthly"} subscription is active.`
        : (status === "unknown" ? "Hang on a moment." : "No charge was made. You can try again any time.");

    return (
        <div className="min-h-screen bg-white flex items-center justify-center p-6">
            <div className="w-full max-w-md text-center fade-in-up" data-testid="payment-return">
                <div className={`inline-flex w-14 h-14 items-center justify-center rounded-2xl ${ok ? "bg-emerald-50 text-emerald-600" : status === "unknown" ? "bg-slate-50 text-slate-500" : "bg-red-50 text-red-600"}`}>
                    <Icon className={`w-7 h-7 ${status === "unknown" ? "animate-spin" : ""}`} strokeWidth={1.75} />
                </div>
                <h1 className="mt-5 text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900" data-testid="payment-return-title">{title}</h1>
                <p className="mt-3 text-sm text-slate-500">{msg}</p>

                <div className="mt-8 flex items-center justify-center gap-2">
                    <Link
                        to="/app"
                        className="inline-flex items-center justify-center rounded-xl bg-indigo-600 text-white px-4 py-2.5 text-sm font-medium hover:bg-indigo-700 transition-colors"
                        data-testid="back-to-app-btn"
                    >
                        Go to dashboard
                    </Link>
                    {!ok && (
                        <Link
                            to="/pricing"
                            className="inline-flex items-center justify-center rounded-xl bg-white border border-slate-200 text-slate-700 px-4 py-2.5 text-sm font-medium hover:bg-slate-50 transition-colors"
                            data-testid="retry-pricing-btn"
                        >
                            Try again
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
